


















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class Settings extends Vue {
    @Prop({ type: String })
    period!: string;
    @Prop({ type: Boolean, default: false })
    isMulti!: boolean;
    @Prop({ type: Array, default: () => [] })
    bookList!: string[];

    isIn = true;
    isToggle = true;
    invoiceTypes = [
        {
            name: "增值税专用发票",
            checked: true
        },
        {
            name: "增值税普通发票",
            checked: true
        },
        {
            name: "增值税电子专用发票",
            checked: true
        },
        {
            name: "增值税电子普通发票",
            checked: true
        },
        {
            name: "增值税通行费电子普通发票",
            checked: true
        },
        {
            name: "机动车销售统一发票",
            checked: true
        },
        {
            name: "二手车销售统一发票",
            checked: true
        }
    ];
    isAll = 0;
    isMonth = 1;

    mounted() {
        if (!this.isMulti || this.bookList.length === 1) this.fetchData();
    }

    async fetchData() {
        console.log(this.$store.state.accountBook.id)
        const res = await Vue.axios.get(`uibot/invoice/get?period=${this.period}&accountBookId=${this.isMulti && this.bookList.length === 1 ? this.bookList[0] : this.$store.state.accountBook.id}`);
        this.isAll = res.data.isAll;
        this.isMonth = res.data.isMonth;

        const types = res.data.invoiceTypeArray;
        this.invoiceTypes.forEach(type => {
            type.checked = false;
            types.forEach((data: string) => {
                if (type.name === data) type.checked = true;
            });
        });
    }

    async startBot() {
        let typeStr = "采集进项发票,";
        this.invoiceTypes.forEach((v, i) => {
            if (v.checked) typeStr += v.name + (i === this.invoiceTypes.length - 1 ? "" : ",");
        });
        const res = await Vue.axios.post(`uibot/invoice/save${this.isMulti ? "/list" : ""}?period=${this.period}&accountBookId=${this.isMulti ? this.bookList.join(",") : this.$store.state.accountBook.id}&isAll=${this.isAll}&isMonth=${this.isMonth}&invoiceType=${typeStr}`);

        this.$msgbox({
            message: res.data,
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: false,
        });

        this.$emit("close", true);
    }
}
